module.exports = __webpack_public_path__ + "static/media/icon-search.ba365564.svg";